var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "back-layout" },
    [
      _c(
        "div",
        { staticClass: "lang-setting" },
        [
          _c(
            "a-select",
            {
              staticClass: "select-list",
              attrs: {
                placeholder: "请选择语言",
                showSearch: "",
                optionFilterProp: "children",
                value: _vm.currentLang,
              },
              on: { change: _vm.handleChangeLang },
            },
            [
              _c(
                "a-select-option",
                {
                  staticClass: "ignore",
                  attrs: { value: "chinese_simplified" },
                },
                [_vm._v("简体中文")]
              ),
              _c(
                "a-select-option",
                {
                  staticClass: "ignore",
                  attrs: { value: "chinese_traditional" },
                },
                [_vm._v("繁體中文")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "english" } },
                [_vm._v("English")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "korean" } },
                [_vm._v("한국어")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "japanese" } },
                [_vm._v("しろうと")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "vietnamese" } },
                [_vm._v("Tiếng Việt")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "hindi" } },
                [_vm._v("हिन्दी")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "russian" } },
                [_vm._v("Русский язык")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "french" } },
                [_vm._v("Français")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "ukrainian" } },
                [_vm._v("УкраїнськаName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "norwegian" } },
                [_vm._v("Norge")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "welsh" } },
                [_vm._v("color name")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "dutch" } },
                [_vm._v("nederlands")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "filipino" } },
                [_vm._v("Pilipino")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "lao" } },
                [_vm._v("ກະຣຸນາ")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "telugu" } },
                [_vm._v("తెలుగుQFontDatabase")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "romanian" } },
                [_vm._v("Română")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "nepali" } },
                [_vm._v("नेपालीName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "haitian_creole" } },
                [_vm._v("Kreyòl ayisyen")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "czech" } },
                [_vm._v("český")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "swedish" } },
                [_vm._v("Svenska")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "malagasy" } },
                [_vm._v("Malagasy")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "burmese" } },
                [_vm._v("ဗာရမ်")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "pashto" } },
                [_vm._v("پښتوName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "thai" } },
                [_vm._v("คนไทย")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "armenian" } },
                [_vm._v("Արմենյան")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "persian" } },
                [_vm._v("Persian")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "kurdish" } },
                [_vm._v("Kurdî")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "turkish" } },
                [_vm._v("Türkçe")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "bulgarian" } },
                [_vm._v("български")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "malay" } },
                [_vm._v("Malay")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "swahili" } },
                [_vm._v("Kiswahili")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "oriya" } },
                [_vm._v("ଓଡିଆ")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "icelandic" } },
                [_vm._v("ÍslandName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "irish" } },
                [_vm._v("Íris")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "khmer" } },
                [_vm._v("ខ្មែរKCharselect unicode block name")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "gujarati" } },
                [_vm._v("ગુજરાતી")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "slovak" } },
                [_vm._v("Slovenská")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "kannada" } },
                [_vm._v("ಕನ್ನಡ್Name")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "hebrew" } },
                [_vm._v("היברית")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "hungarian" } },
                [_vm._v("magyar")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "marathi" } },
                [_vm._v("मराठीName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "tamil" } },
                [_vm._v("தாமில்")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "estonian" } },
                [_vm._v("eesti keel")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "malayalam" } },
                [_vm._v("മലമാലം")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "inuktitut" } },
                [_vm._v("ᐃᓄᒃᑎᑐᑦ")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "arabic" } },
                [_vm._v("بالعربية")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "deutsch" } },
                [_vm._v("Deutsch")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "slovene" } },
                [_vm._v("slovenščina")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "bengali" } },
                [_vm._v("বেঙ্গালী")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "urdu" } },
                [_vm._v("اوردو")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "azerbaijani" } },
                [_vm._v("azerbaijani")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "portuguese" } },
                [_vm._v("português")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "samoan" } },
                [_vm._v("lifiava")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "afrikaans" } },
                [_vm._v("afrikaans")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "tongan" } },
                [_vm._v("汤加语")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "greek" } },
                [_vm._v("ελληνικά")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "indonesian" } },
                [_vm._v("IndonesiaName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "spanish" } },
                [_vm._v("Español")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "danish" } },
                [_vm._v("dansk")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "amharic" } },
                [_vm._v("amharic")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "punjabi" } },
                [_vm._v("ਪੰਜਾਬੀName")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "albanian" } },
                [_vm._v("albanian")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "lithuanian" } },
                [_vm._v("Lietuva")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "italian" } },
                [_vm._v("italiano")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "maltese" } },
                [_vm._v("Malti")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "finnish" } },
                [_vm._v("suomi")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "catalan" } },
                [_vm._v("català")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "croatian" } },
                [_vm._v("hrvatski")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "bosnian" } },
                [_vm._v("bosnian")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "polish" } },
                [_vm._v("Polski")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "latvian" } },
                [_vm._v("latviešu")]
              ),
              _c(
                "a-select-option",
                { staticClass: "ignore", attrs: { value: "maori" } },
                [_vm._v("Maori")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          class: ["user-layout-wrapper", _vm.device],
          attrs: { id: "userLayout" },
        },
        [
          _c("div", { staticClass: "container" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "right-form" },
              [
                _c("div", { staticClass: "top" }, [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c(
                        "a-row",
                        [
                          _c("a-col", [
                            _c("a", { attrs: { href: "/" } }, [
                              _c("span", { staticClass: "title" }, [
                                _vm._v(_vm._s(_vm.systemTitle)),
                              ]),
                              _c("small", { staticClass: "desc" }, [
                                _vm._v("V3.6"),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("route-view"),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm.device === "desktop"
        ? _c("div", { staticClass: "footer" }, [
            _vm.isShowRight
              ? _c("div", { staticClass: "third-party-platform" }, [
                  _c(
                    "div",
                    {
                      staticClass: "platform-info",
                      on: {
                        click: function ($event) {
                          return _vm.openAndroid()
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "30px" },
                        attrs: { src: "/static/Android.png" },
                      }),
                      _c("span", [_vm._v("安卓版")]),
                    ]
                  ),
                  _c("div", { staticStyle: { width: "50px" } }),
                  _c(
                    "div",
                    {
                      staticClass: "platform-info",
                      on: {
                        click: function ($event) {
                          return _vm.openIPhone()
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "30px" },
                        attrs: { src: "/static/iPhone.png" },
                      }),
                      _c("span", [_vm._v("iPhone版")]),
                    ]
                  ),
                  _c("div", { staticStyle: { width: "50px" } }),
                  _c(
                    "div",
                    {
                      staticClass: "platform-info",
                      on: {
                        click: function ($event) {
                          return _vm.openMiniProgram()
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "30px" },
                        attrs: { src: "/static/mini-program.png" },
                      }),
                      _c("span", [_vm._v("小程序版")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("p", [
              this.isShowRight ? _c("span", [_vm._v("忙果科技")]) : _vm._e(),
              _vm._v(
                "\n      © 2015-2030 " +
                  _vm._s(_vm.systemTitle) +
                  " - All Right Reserved 版权所有\n      "
              ),
              _c(
                "a",
                {
                  staticStyle: { color: "#00458a", "padding-right": "10px" },
                  attrs: { href: _vm.systemUrl, target: "_blank" },
                },
                [_vm._v("官方网站")]
              ),
              this.isShowRight
                ? _c("span", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://beian.miit.gov.cn/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("苏ICP备2021042833号")]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: { title: "微信扫一扫下载安卓版", width: "200", centered: "" },
          model: {
            value: _vm.isAndroidShow,
            callback: function ($$v) {
              _vm.isAndroidShow = $$v
            },
            expression: "isAndroidShow",
          },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                { key: "back", on: { click: _vm.handleAndroidCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "platform-modal" }, [
            _c("img", {
              staticStyle: { width: "200px" },
              attrs: { src: "/static/android-code.png" },
            }),
          ]),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "微信扫一扫下载iPhone版",
            width: "200",
            centered: "",
          },
          model: {
            value: _vm.isIphoneShow,
            callback: function ($$v) {
              _vm.isIphoneShow = $$v
            },
            expression: "isIphoneShow",
          },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                { key: "back", on: { click: _vm.handleIphoneCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "platform-modal" }, [
            _c("img", {
              staticStyle: { width: "200px" },
              attrs: { src: "/static/iphone-code.png" },
            }),
          ]),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "微信扫一扫使用小程序版",
            width: "200",
            centered: "",
          },
          model: {
            value: _vm.isMiniProgramShow,
            callback: function ($$v) {
              _vm.isMiniProgramShow = $$v
            },
            expression: "isMiniProgramShow",
          },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                { key: "back", on: { click: _vm.handleMiniProgramCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "platform-modal" }, [
            _c("img", {
              staticStyle: { width: "200px" },
              attrs: { src: "/static/weixin-code.png" },
            }),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "poster-img" }, [
      _c("img", { attrs: { src: "/static/rightImg.png?v=320" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }